import React, { useState } from "react";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button, TextInput } from "flowbite-react";

function Login() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    axios
      .post("https://jewellery-mysql-backend.onrender.com/user/login", { email, password})
      .then((result) => {
        // if (result.statusText === "OK") {
        //   navigate("/admin/dashboard/uploadimage");
        //   setErrorMessage("");
        // }
        // Store token in localStorage
        //console.log(result)
        localStorage.setItem("token", result.data.token);
        navigate("/admin/dashboard/uploadimage");
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage("Invalid Email and password.");
      });
  };
  return (
    <div className="mobile-view px-4 my-12 m-auto lg:w-[500px] md:w-[500px] sm:w-[400px]">
      <div className="">
        <div className="">
          <div className="">
            <h1 className="font-bold text-3xl mb-6 text-center">
              Login to your account
            </h1>
          </div>
          <form action="" className="flex flex-col gap-6">
            <div>
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-medium text-gray-900"
              >
                Email
              </label>
              <TextInput
                type="text"
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
                name="email"
                className="w-full rounded"
              />
            </div>
            <div>
              <div>
                <label
                  htmlFor="password"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  Password
                </label>
                <TextInput
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  name="password"
                  className="w-full rounded"
                />
              </div>
            </div>
            {errorMessage && (
              <div className="error_message mb-3 text-danger">
                {errorMessage}
              </div>
            )}
              <Button onClick={handleSubmit} type="submit">
                Login In
              </Button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
